import React from 'react';

function CarriculamTable (props){
        return (props.carriculamTables === undefined ? "" : (<div>
            <table id="customers">
                <tr>
                    <th>Module</th>
                    <th>Detailed topics covered in each module</th>
                </tr>
                {
                    props.carriculamTables.map((table) => {
                        return (
                            table.ColSpan === true ? (
                                <tr class="columnSpan">
                                    <td colspan="2"><b>{table.Module}</b></td>
                                </tr>
                            )
                                : (
                                    <tr>
                                        <td>{table.Module}</td>
                                        <td>{table.Topics}</td>
                                    </tr>
                                )
                        )

                    })
                }
            </table>
        </div>)
        )

    }

export default CarriculamTable;

